import { useContext, useEffect, useState } from "react";
import Flex from "../../../components/Flex"

import "./layout.scss";
import { MenuContext } from "../../../contexts/MenuContext";
import { spacing } from "../styles";
import { Link, Location} from "react-router-dom";
import datasource from "../../../datasource";
import MobileIcon from "../../../components/MobileIcon";
import useNav from "../../../components/useNav";

interface MenuItemType {
    idx: number
    title: string
    path: string 
    children?: MenuItemType[]
}

const menuData:MenuItemType[] = datasource.menuData
const portal = datasource.portal


export default () => {

    const [open, setOpen] = useState<boolean>(() => false)
    const {render, open: openMenu} = useMenu(() => setOpen(false))
    const {current, setCurrent} = useContext(MenuContext)


    const toggleOpen = () => {
        setOpen(_open => !_open)
    }

    useEffect(() => {
        openMenu(open)
    }, [open])

    useEffect(() => {
        setOpen(false)
    }, [current])

    return (
        <div className={["mb-layout__header-box", open?"mb-layout__header-box_activate":""].join(" ")}>
            <Flex className={["mb-layout__header", open?"mb-layout__header_activate":""].join(" ")} justify="space-between" align="center">
                <Logo></Logo>
                {
                    open
                    ?
                    <MobileIcon.MobileMenuBtnOpened width={24} height={24} onClick={toggleOpen}/>
                    :
                    <MobileIcon.MobileMenuBtnClosed width={32} height={32} onClick={toggleOpen}/>
                }
            </Flex>
            {render}
        </div>
    )
}

const Logo = () => {

    const {nav} = useNav();

    return (
        <Flex className="mb-layout__header__logo" align="center">
            <Flex gap={spacing("md")} align="center">
                <MobileIcon.MobileLogo width={32} height={32} onClick={() => nav("/")}></MobileIcon.MobileLogo>
                Roundblock
            </Flex>
            
        </Flex>
    )
}

const useMenu = (close: () => void) => {

    const [show, setShow] = useState<boolean>()
    const [disapear, setDisapear] = useState<boolean>()
    

    const render = (
        <div className={["mb-menu", show?"mb-menu_activate":"", disapear?"mb-menu_disapear":""].join(" ")}>
            <Flex gap={spacing("md")} vertical>
                {
                    menuData.map(it => <MenuItem item={it}></MenuItem>)
                }
            </Flex>
            <div className="mb-menu__cta">
                <a
                    className="mb-menu__cta__link"
                    href={portal.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={close}
                >
                    <Flex gap={spacing("md")} reposive={false} align="center" justify="center">
                        {portal.label}
                        <MobileIcon.ArrowUp width={16} height={16}></MobileIcon.ArrowUp>
                    </Flex>
                </a>
            </div>
        </div>
    )

    const open = (flag: boolean) => {
        if(!flag){
            setTimeout(() => {
                setDisapear(true)
            }, 300);
        }else{
            setDisapear(false)
        }
        setShow(flag)
    }

    return {
        render,
        open
    }
}

const MenuItem = (props: {item: MenuItemType}) => {

    const {
        item
    } = props
    const {current, setCurrent} = useContext(MenuContext)
    const {nav} = useNav();

    const doClick = () => {
        setCurrent([item.idx])
        nav(item.path)
        document.scrollingElement?.scrollTo({top: 0, behavior: "smooth"})
    }

    return (
        <Flex
            className={["mb-menu__item", current[0] == item.idx?"mb-menu__item_activate":""].join(" ")}
            onClick={doClick}
            gap={16}
            justify="space-between"
            align="center"
        >
            <div>{item.title}</div>
        </Flex>
    )
}


export function calCurrentMenu(location: Location){

    const path = location.pathname
    switch(path){
        case "/products":
        case "/translation-service":
        case "/webhosting-service":
        case "/products/aaolens":
            return [1]
        case "/careers":
            return [2]
        default:
            return [0]

    }

}